import { FC, Dispatch, useEffect, useState } from "react";
import { StopEventPropagation } from "../../../helper/ui/methods";
import { UserInterface } from "../../../middleware/interfaces/user/user-interface";
import {
  BytesToReadableSize,
  FormatDateFE,
} from "../../../helper/general/methods";

interface userSubscriptionDialogProps {
  user: UserInterface;
  dispatch: Dispatch<any>;
}

const UserSubscriptionDialog: FC<userSubscriptionDialogProps> = ({
  user,
  dispatch,
}) => {
  const [cancel, setCancel] = useState(false);

  useEffect(() => {
    if (cancel) {
      const updatedUser = { ...user, subscription: null };
      dispatch({
        type: "UPDATE_USER",
        payload: updatedUser,
        response: "",
      });
      setCancel(false);
    }
  }, [cancel]);

  return (
    <>
      {(() => {
        if (user.subscription) {
          return (
            <div className="dialogCover" onClick={StopEventPropagation}>
              <div className="dialog dialogWide">
                <div className="dialogHeader">
                  <div className="dialogHeading">
                    <h2 className="dialogTitle">Subscription</h2>
                  </div>
                  <span className="dialogClose" onClick={() => setCancel(true)}>
                    ×
                  </span>
                </div>
                <div className="dialogBody dialogFieldGrid">
                  <div className="dialogValueWrapper">
                    <span className="dialogInputLabel">Subscription plan</span>
                    <input
                      type="text"
                      name="subscriptionPlan"
                      value={user.subscription.userSubscriptionPlan}
                      readOnly
                    />
                  </div>
                  <div className="dialogValueWrapper">
                    <span className="dialogInputLabel">Subscription status</span>
                    <input
                      type="text"
                      name="subscriptionStatus"
                      value={user.subscription.userSubscriptionStatus}
                      readOnly
                    />
                  </div>
                  <div className="dialogValueWrapper">
                    <span className="dialogInputLabel">Start date</span>
                    <input
                      type="text"
                      name="subscriptionStartDate"
                      value={FormatDateFE(
                        user.subscription.userSubscriptionStartDate,
                        true
                      )}
                      readOnly
                    />
                  </div>
                  <div className="dialogValueWrapper">
                    <span className="dialogInputLabel">End date</span>
                    <input
                      type="text"
                      name="subscriptionEndDate"
                      value={FormatDateFE(
                        user.subscription.userSubscriptionEndDate,
                        true
                      )}
                      readOnly
                    />
                  </div>
                  <div className="dialogValueWrapper">
                    <span className="dialogInputLabel">Total report size</span>
                    <input
                      type="text"
                      name="totalReportSize"
                      value={BytesToReadableSize(
                        user.subscription.userSubscriptionTotalSpaceUsed[
                          "TotalReportSize"
                        ]
                      )}
                      readOnly
                    />
                  </div>
                  <div className="dialogValueWrapper">
                    <span className="dialogInputLabel">Total file size</span>
                    <input
                      type="text"
                      name="totalFileSize"
                      value={BytesToReadableSize(
                        user.subscription.userSubscriptionTotalSpaceUsed[
                          "TotalFileSize"
                        ]
                      )}
                      readOnly
                    />
                  </div>
                  <div className="dialogValueWrapper">
                    <span className="dialogInputLabel">Total space available</span>
                    <input
                      type="text"
                      name="totalSpaceAvailable"
                      value={BytesToReadableSize(
                        user.subscription.userSubscriptionTotalSpaceAvailable
                      )}
                      readOnly
                    />
                  </div>
                </div>
                <div className="dialogButtonWrapper">
                  <input
                    className="dialogPrimaryButton"
                    type="button"
                    name="cancel"
                    value="Cancel"
                    onClick={() => setCancel(true)}
                  />
                  <input
                    type="button"
                    name="subscribe"
                    value="Subscribe"
                    onClick={() =>
                      window.open(
                        "https://apps.autodesk.com/NAVIS/en/Detail/Index?id=7615486252567671603&appLang=en&os=Win64",
                        "_blank"
                      )
                    }
                  />
                </div>
              </div>
            </div>
          );
        } else {
          return <></>;
        }
      })()}
    </>
  );
};

export default UserSubscriptionDialog;
